import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-314d9f13"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "checked"]
const _hoisted_2 = ["for"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "toggle-label-circle" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "toggle-label-circle-inner" })
], -1))
const _hoisted_4 = { class: "toggle-label-text toggle-label-text-left" }
const _hoisted_5 = { class: "toggle-label-text toggle-label-text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("input", {
      id: _ctx.id,
      type: "checkbox",
      class: "toggle-input",
      checked: _ctx.checked,
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChange && _ctx.onChange(...args)))
    }, null, 40, _hoisted_1),
    _createElementVNode("label", {
      for: _ctx.id,
      class: _normalizeClass(['toggle-label', _ctx.colorClass, _ctx.sizeClass])
    }, [
      _hoisted_3,
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.checkedText), 1),
      _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.unCheckedText), 1)
    ], 10, _hoisted_2)
  ]))
}